import {
  DocumentDetailResponse,
  UserDetailResponse,
} from "apis/data-contracts";
import {
  APPROVABLE_APPROVE_STATUS,
  EDITABLE_APPROVE_STATUS,
} from "config/documentConstant";
import { DocumentAccessType } from "models/document/DocumentAccessType";

interface CheckDocumentAccessTypeProps {
  user: UserDetailResponse;
  document: DocumentDetailResponse;
}

export default function checkDocumentAccessType({
  user,
  document,
}: CheckDocumentAccessTypeProps): DocumentAccessType {
  const hasAuthorityListReadAccess =
    !!user.authorityDto &&
    document.authorityList?.some(
      (authority) =>
        !!authority &&
        (authority.uuid === user.authorityDto?.uuid ||
          authority.name === user.authorityDto?.name),
    );

  const hasReferenceUserReadAccess = document.referenceUsers?.some(
    (referenceUser) => referenceUser.uuid === user.uuid,
  );

  const hasAuthorityToApprove =
    (document.permissionType === "APPROVER" ||
      (document.permissionType === "OWNER" &&
        user.adminType === "SUPERADMIN")) &&
    document.approveStatus &&
    APPROVABLE_APPROVE_STATUS.includes(document.approveStatus);

  const canEdit =
    document.permissionType === "OWNER" &&
    (!document.approveStatus ||
      EDITABLE_APPROVE_STATUS.includes(document.approveStatus));

  const canRead =
    document.permissionType === "OWNER" ||
    document.permissionType === "APPROVER" ||
    document.permissionType === "REFERRER" ||
    document.permissionType === "READER" ||
    hasAuthorityListReadAccess ||
    hasReferenceUserReadAccess ||
    !!user.adminType;

  if (hasAuthorityToApprove) {
    return "APPROVABLE";
  } else if (canEdit) {
    return "EDITABLE";
  } else if (canRead) {
    return "READ_ONLY";
  } else {
    return "BLOCK";
  }
}
